<template>
  <mf-loading-dialog :loading="isLoadingCampaign">
    <base-page-layout title="Histórico de utilização">
      <template v-if="['ACTIVE', 'FINISHED'].includes(benefit.status)" v-slot:title-complement>
        <div v-if="benefit.status === 'ACTIVE'" class="pl-3">
          <mf-button label="Editar o cupom" outlined text-transform="none" icon="edit" icon-position="left" @click="emitEditFunction" />
        </div>
        <div class="pl-3">
          <mf-button label="Ver resultados do cupom" outlined text-transform="none" icon="monitoring" icon-position="left" @click="emitResultsFunction" />
        </div>
      </template>
      <div class="usage-history-container">
        <info-card />
        <div class="report-button">
          <export-email-report-dialog
            ref="exportEmailReportDialog"
            title="Enviar relatório de histórico de utilização de cupons"
            description="O relatório de histórico de utilização é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo contendo todas as informações detalhadas é enviado em anexo ao e-mail."
            :exportReportFn="exportProductsAnalysis"
            :iconSize="18"
            async
            variant="secondary"
            :disabled="!hasPiiAccess"
            @file-format="getFileFormat"
          />
        </div>
        <usage-history-table />
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Fechar',
            action: backToIndex,
            isVisible: true,
            isLoading: loadingPrimaryButton,
          }"
        />
      </div>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import InfoCard from '../components/results/InfoCard.vue'
import BasePageLayout from '@/components/BasePageLayout.vue'
import UsageHistoryTable from '../components/usage-history/UsageHistoryTable.vue'
import { couponDiscount } from '../../mixins/coupon-discount'
import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
export default {
  name: 'CouponUsageHistory',
  components: { InfoCard, BasePageLayout, UsageHistoryTable, ExportEmailReportDialog },
  mixins: [couponDiscount],
  props: {},
  data: () => ({
    isLoadingCampaign: false,
    loadingPrimaryButton: false,
    fileFormat: 'CSV',
    benefitId: null,
  }),
  computed: {
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    hasPiiAccess() {
      return this.$hasPiiAccess()
    },
  },
  mounted() {
    this.benefitId = this.$route.params.id
    this.waitAndGetData()
  },
  methods: {
    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportProductsAnalysis(emails) {
      try {
        const variables = { emails, fileFormat: this.fileFormat, benefitId: this.benefitId }
        const exportData = await this.exportBenefitMovementHistoryReport(variables)
        return exportData
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao exportar relatório.', snackbarColor: 'error' })
      }
    },
    backToIndex() {
      this.loadingPrimaryButton = true
      let routeName = 'cupom-desconto'
      this.$router.push({ name: routeName }).catch(() => {})
    },
    async waitAndGetData() {
      this.isLoadingCampaign = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        await this.getBenefitMetricsById({ id: this.benefitId, franchise: this.isFranchisee })
        this.isLoadingCampaign = false
      }, 500)
    },
    emitEditFunction() {
      const route = this.$router.resolve({ name: 'cupom-desconto-editar', params: { id: this.benefit._id } })
      window.open(route.href, '_blank')
    },
    emitResultsFunction() {
      const route = this.$router.resolve({ name: 'cupom-desconto-resultados', params: { id: this.benefit._id } })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.usage-history-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  .report-button {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
